const routes = {
    login: "/login",
    landing: "/",
    setNewPassword: "/set-new-password",
    resetPassword: "/reset-password",
    changePassword: "/change-password/user/:id",
    dealFertilizers: "/deals/fertilizers",
    dealFoods: "/deals/foods",
    dealMiscellaneous: "/deals/miscellaneous",
    dealPetrochemicals: "/deals/petrochemicals/feedstocks",
    dealPolymers: "/deals/polymers",
    dealSBLC: "/deals/sblc",
    entityBanks: "/entities/banks",
    entityCounterParties: "/entities/counter-parties",
    entityDeals: "/entities/deals",
    entityDealPFIs: "/entities/deal-pfis",
    entityDropdowns: "/entities/dropdowns",
    entityFileTypes: "/entities/file-types",
    entityProducts: "/entities/products",
    entitySBLC: "/entities/sblc",
    entityTenors: "/entities/tenors",
    entityTraders: "/entities/traders",
    reportDealReport: "/reports/deal-report",
    reportFinanceReport: "/reports/finance-report",
    reportMorningReport: "/reports/morning-report",
    reportTreasuryReport: "/reports/treasury-report",
    reportPreShipmentReport: "/reports/pre-shipment-report",
    reportDocuments: "/reports/report-documents/:trancheId/:fileType",
    kycNewKYC: "/kyc/new-kyc",
    kycRequests: "/kyc/requests",
    kycRequestsDetails: "/kyc/requests/:kyc_id",
    kycEditKYC: "/kyc/edit-kyc",
    kycCounterPartyList: "/kyc/counter-party-list",
    auditTrailFinance: "/audit-trail/finance",
    auditTrailUser: "/audit-trail/user",
    approveDocuments: "/documents/approve-documents",
    approveDocumentsDetails: "/documents/approve-documents/:deal_no",
    documentRequests: "/documents/document-requests",
    massUpdate: "/mass-update",
    settings: "/period-lock/settings",
    periodLockRequests: "/period-lock/requests",
    userManagement: "/user-management",
    addUser: "/user-management/add-user",
    editProfile: "/account/edit-profile",
    pageNotFound: "*"
};

export default routes;

export const allowedRoutesByRole = {
    [process.env.REACT_APP_ROLE_SECRET_KEY_1]: [
        "/user-management",
        "/user-management/add-user",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_2]: [
        "/",
        "/deals/fertilizers",
        "/deals/foods",
        "/deals/miscellaneous",
        "/deals/petrochemicals/feedstocks",
        "/deals/polymers",
        "/deals/sblc",
        "/entities/counter-parties",
        "/entities/sblc",
        "/reports/treasury-report",
        "/documents/document-requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/period-lock/requests",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_3]: [
        "/",
        "/deals/fertilizers",
        "/deals/foods",
        "/deals/miscellaneous",
        "/deals/petrochemicals/feedstocks",
        "/deals/polymers",
        "/deals/sblc",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_4]: [
        "/",
        "/deals/fertilizers",
        "/deals/miscellaneous",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/products",
        "/entities/sblc",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/documents/document-requests",
        "/kyc/edit-kyc",
        "/period-lock/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_5]: [
        "/",
        "/deals/fertilizers",
        "/deals/miscellaneous",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/products",
        "/entities/sblc",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/documents/document-requests",
        "/kyc/edit-kyc",
        "/period-lock/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_6]: [
        "/",
        "/deals/fertilizers",
        "/deals/miscellaneous",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/kyc/edit-kyc",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_7]: [
        "/",
        "/deals/fertilizers",
        "/deals/foods",
        "/deals/miscellaneous",
        "/deals/petrochemicals/feedstocks",
        "/deals/polymers",
        "/deals/sblc",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/kyc/edit-kyc",
        "/kyc/counter-party-list",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_8]: [
        "/",
        "/deals/fertilizers",
        "/deals/foods",
        "/deals/miscellaneous",
        "/deals/petrochemicals/feedstocks",
        "/deals/polymers",
        "/deals/sblc",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/documents/document-requests",
        "/period-lock/settings",
        "/period-lock/requests",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_9]: [
        "/",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/dropdowns",
        "/entities/file-types",
        "/entities/products",
        "/entities/tenors",
        "/entities/traders",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_10]: [
        "/",
        "/deals/foods",
        "/deals/miscellaneous",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/products",
        "/entities/sblc",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/documents/document-requests",
        "/kyc/edit-kyc",
        "/period-lock/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_11]: [
        "/",
        "/deals/foods",
        "/deals/miscellaneous",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/products",
        "/entities/sblc",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/documents/document-requests",
        "/kyc/edit-kyc",
        "/period-lock/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_12]: [
        "/",
        "/deals/foods",
        "/deals/miscellaneous",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/kyc/edit-kyc",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_13]: [
        "/",
        "/deals/miscellaneous",
        "/deals/polymers",
        "/deals/sblc",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/products",
        "/entities/sblc",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/documents/document-requests",
        "/kyc/edit-kyc",
        "/period-lock/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_14]: [
        "/",
        "/deals/miscellaneous",
        "/deals/polymers",
        "/deals/sblc",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/products",
        "/entities/sblc",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/documents/document-requests",
        "/kyc/edit-kyc",
        "/period-lock/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_15]: [
        "/",
        "/deals/miscellaneous",
        "/deals/polymers",
        "/deals/sblc",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/edit-kyc",
        "/kyc/requests/:kyc_id",
        "/kyc/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_16]: [
        "/",
        "/deals/miscellaneous",
        "/deals/petrochemicals/feedstocks",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/products",
        "/entities/sblc",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/documents/document-requests",
        "/kyc/edit-kyc",
        "/period-lock/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_17]: [
        "/",
        "/deals/miscellaneous",
        "/deals/petrochemicals/feedstocks",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/products",
        "/entities/sblc",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/new-kyc",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/documents/document-requests",
        "/kyc/edit-kyc",
        "/period-lock/requests",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/mass-update",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_18]: [
        "/",
        "/deals/miscellaneous",
        "/deals/petrochemicals/feedstocks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/kyc/edit-kyc",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_19]: [
        "/",
        "/deals/fertilizers",
        "/deals/foods",
        "/deals/miscellaneous",
        "/deals/petrochemicals/feedstocks",
        "/deals/polymers",
        "/deals/sblc",
        "/entities/banks",
        "/entities/counter-parties",
        "/entities/deals",
        "/entities/deal-pfis",
        "/entities/dropdowns",
        "/entities/file-types",
        "/entities/products",
        "/entities/tenors",
        "/entities/traders",
        "/reports/deal-report",
        "/reports/finance-report",
        "/reports/morning-report",
        "/reports/treasury-report",
        "/reports/pre-shipment-report",
        "/reports/report-documents/:trancheId/:fileType",
        "/kyc/requests",
        "/kyc/requests/:kyc_id",
        "/kyc/counter-party-list",
        "/documents/approve-documents",
        "/documents/approve-documents/:deal_no",
        "/account/edit-profile"
    ],
    [process.env.REACT_APP_ROLE_SECRET_KEY_20]: [
        "/",
        "/audit-trail/finance",
        "/audit-trail/user",
        "/account/edit-profile"
    ]
};

export const getRoutesByRole = (role) => {
    return allowedRoutesByRole[role] || [];
};